const clearCommand: BerkeliumCommand = {
  name: 'clear',
  description: 'Clear the terminal screen and start a fresh conversation',
  prompt: 'Clear the terminal and reset the conversation context'
};

export default clearCommand;